import { useEffect, useState } from "react";
import { useAuthContext } from "./useAuthContext";
import { firebaseAuth } from "../firebase/config";

export const useLogin = () => {
  const [isCancelled, setIsCancelled] = useState(false);
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);
  const { dispatch } = useAuthContext();

  const login = async (email, password) => {
    setIsPending(true);
    setError(null);

    try {
      //try to log the user in
      const res = await firebaseAuth.signInWithEmailAndPassword(
        email,
        password
      );

      //dispatch login action
      dispatch({ type: "LOGIN", payload: res.user });

      //don't update the state if the component has been unmounted
      if (!isCancelled) {
        setIsPending(false);
        setError(null);
      }
    } catch (error) {
      if (!isCancelled) {
        setIsPending(false);
        setError(error.message);
      }
    }
  };

  useEffect(() => {
    return () => setIsCancelled(true);
  }, []);

  //return the login function, error, isPending
  return { isPending, error, login };
};
